<template>
  <el-card shadow="never" v-loading="loading">
    <transition name="el-fade-in-linear">
      <el-card v-show="!preview" shadow="never" v-loading="loading">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="Company"></el-step>
          <el-step title="Contact"></el-step>
          <el-step title="Backup"></el-step>
          <el-step title="Lease Details"></el-step>
          <el-step title="NAICS"></el-step>
          <el-step title="Utilities"></el-step>
          <el-step title="Signature"></el-step>
        </el-steps>
        <el-card shadow="never">
          <el-card v-show="active === 0" shadow="never">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
            </template>
            <el-form ref="company" :rules="companyRules" :model="companyForm">
              <el-form-item label="Company name">
                <el-input :disabled="true" v-model="customer.company">
                </el-input>
              </el-form-item>
              <el-form-item label="Type Of Entity" prop="typeOfEntity" :rules="[
                {
                  required: true,
                  message: 'Please select Entity',
                  trigger: 'change',
                },
              ]">
                <el-select v-model="companyForm.typeOfEntity">
                  <el-option
                    v-for="entity in entityOptions"
                    :key="entity.value"
                    :label="entity.label"
                    :value="entity.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Tax ID" prop="taxId" :rules="[
                {
                  required: true,
                  message: 'Please add Customer Tax ID',
                  trigger: 'blur',
                },
              ]">
                <el-input v-model="companyForm.taxId">
                </el-input>
              </el-form-item>
              <el-form-item label="Country" prop="country" :rules="[
                {
                  required: true,
                  message: 'Please select Country',
                  trigger: 'change',
                },
              ]">
                <el-select v-model="companyForm.country"  @change="() => companyForm.state = ''">
                  <el-option
                    v-for="country in countries"
                    :key="country.value"
                    :label="country.label"
                    :value="country.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Organization State" prop="state" :rules="[
                {
                  required: companyForm.country !== 'bh',
                  message: 'Please select State',
                  trigger: 'change',
                },
              ]">
                <State
                  v-show="companyForm.country"
                  :country="companyForm.country"
                  :given-state="companyForm.state"
                  @change="setState"
                />
              </el-form-item>
            </el-form>
          </el-card>
          <el-card shadow="never" v-show="active === 1">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
            </template>
            <el-form ref="contact" :model="contactForm">
              <el-form-item
                label="Representative Name"
                :rules="[
                  {
                    required: true,
                    message: 'Please add representative name',
                    trigger: 'change',
                  },
                ]"
                prop="name"
                >
                  <el-input v-model="contactForm.name">
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="Title"
                  :rules="[
                    {
                      required: true,
                      message: 'Please add title',
                      trigger: 'change',
                    },
                  ]"
                  prop="title"
                  >
                  <el-input v-model="contactForm.title">
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="Address"
                  :rules="[
                    {
                      required: true,
                      message: 'Please add address',
                      trigger: 'change',
                    },
                  ]"
                  prop="address"
                  >
                  <el-input v-model="contactForm.address">
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="Address Line 2"
                  prop="address2"
                  >
                  <el-input v-model="contactForm.address2">
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="City State Postcode"
                  :rules="[
                    {
                      required: true,
                      message: 'Please add City State and Post code',
                      trigger: 'change',
                    },
                  ]"
                  prop="cityStatePostcode"
                >
                  <el-input v-model="contactForm.cityStatePostcode">
                  </el-input>
                </el-form-item>
                <el-form-item label="Country">
                  <el-input :value="countrySelected" disabled>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="Phone"
                  :rules="[
                    {
                      required: true,
                      message: 'Please add phone',
                      trigger: 'change',
                    },
                  ]"
                  prop="phone"
                  >
                  <el-input v-model="contactForm.phone">
                  </el-input>
                </el-form-item>
                <el-form-item label="Email"
                  prop="email"
                  :rules="[
                    {
                      type: 'email',
                      required: true,
                      message: 'Please add email',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-input
                    v-model="contactForm.email"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
          </el-card>
          <el-card shadow="never" v-show="active === 2">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
            </template>
            <el-form ref="backup" :model="customerContactBackup">
              <el-form-item label="Contact Name">
                <el-input v-model="customerContactBackup.name">
                </el-input>
              </el-form-item>
              <el-form-item label="Address">
                <el-input v-model="customerContactBackup.address1">
                </el-input>
              </el-form-item>
              <el-form-item label="City State Postcode">
                <el-input v-model="customerContactBackup.address2">
                </el-input>
              </el-form-item>
              <el-form-item label="Phone">
                <el-input v-model="customerContactBackup.phone">
                </el-input>
              </el-form-item>
              <el-form-item label="Email" :rules="[{
                      type: 'email',
                      message: 'Please add email',
                      trigger: 'change',
                    }]" prop="email">
                <el-input v-model="customerContactBackup.email">
                </el-input>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card v-show="active === 3" shadow="never">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
            </template>
            <el-form ref="details" :model="details">
              <el-form-item label="Initial Term" prop="term" :rules="[
                    {
                      required: true,
                      message: 'Please add term',
                      trigger: 'change',
                    },
                  ]">
                <el-input v-model="details.term"></el-input>
              </el-form-item>
              <el-form-item label="Hours of Access" prop="hoursOfAccess" :rules="[
                    {
                      required: true,
                      message: 'Please add Hours of access value',
                      trigger: 'change',
                    },
                  ]">
                <el-input v-model="details.hoursOfAccess"></el-input>
              </el-form-item>
              <el-form-item label="Max On Site Employees" prop="onSiteEmployees" :rules="[
                    {
                      required: true,
                      message: 'Please add on site employees',
                      trigger: 'change',
                    },
                  ]">
                <el-input v-model="details.onSiteEmployees"></el-input>
              </el-form-item>
              <el-form-item label="Industry" prop="industry" :rules="[
                    {
                      required: true,
                      message: 'Please select industry',
                      trigger: 'change',
                    },
                  ]">
                <el-select v-model="details.industry">
                  <el-option :key="option" v-for="option of industryOptions" :value="option">
                    {{ option }}
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Use Of Space" prop="subIndustry" :rules="[
                    {
                      required: true,
                      message: 'Please select sub industry',
                      trigger: 'change',
                    },
                  ]">
                <el-select v-model="details.subIndustry">
                  <el-option :key="option" v-for="option of subIndustryOptions" :value="option"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card shadow="never" v-show="active === 4">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
            </template>
            <el-form ref="naics">
              <el-form-item label="NAICS Code of member -NJ Only">
                <el-input v-model="naics"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card shadow="never" v-show="active === 5">
            <template slot="header">
              <el-button style="float: right; margin: 10px;" type="primary" @click="next">Next</el-button>
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
            </template>
            <el-form ref="utilities">
              <el-form-item label="ReadySpaces Improvements">
                <el-input v-model="utilities.rsImprovements"></el-input>
              </el-form-item>
              <el-form-item label="Member Obligation Improvements">
                <el-input v-model="utilities.memberObligationImprovements"></el-input>
              </el-form-item>
              <el-form-item label="Member Right Improvements">
                <el-input v-model="utilities.memberRightImprovements"></el-input>
              </el-form-item>
              <el-form-item label="Utilities, Rights, etc">
                <el-input v-model="utilities.utils"></el-input>
              </el-form-item>
              <el-form-item label="Lienholders">
                <el-input v-model="utilities.lienHolders"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card shadow="never" v-show="active === 6">
            <template slot="header">
              <el-button style="float: left; margin: 10px;" @click="() => active--">Back</el-button>
              <el-button
                style="float: right; margin: 10px;" type="warnign"
                @click="generatePdf"
              >
                Preview
              </el-button>
            </template>
            <el-form ref="manager">
              <el-form-item label="Manager Name">
                <el-input :disabled="true" v-model="managerName"></el-input>
              </el-form-item>
              <el-form-item label="Manager Title">
                <el-input :disabled="true" :value="managerTitle"></el-input>
              </el-form-item>
              <el-form-item label="Representative Name">
                <el-input v-model="contactForm.name"></el-input>
              </el-form-item>
              <el-form-item label="Representative Title">
                <el-input v-model="contactForm.title"></el-input>
              </el-form-item>
            </el-form>
          </el-card>
        </el-card>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card v-show="preview" shadow="hover" v-loading="loading">
        <template slot="header">
          <el-button @click="() => preview = false">Edit</el-button>
          <el-button
            :disabled="page === totalPages"
            @click="() => page = Number(page + 1)"
            icon="el-icon-arrow-right"
            circle
            style="float: right"
          ></el-button>
          <el-button
          :disabled="page === 1"
          @click="() => page = Number(page - 1)"
          icon="el-icon-arrow-left"
          circle
          style="float: right"
          ></el-button>
        </template>
        <pdf
          v-if="pdf"
          ref="pdf"
          :src="pdf"
          :page="page"
          @num-pages="totalPages = $event"
          @link-clicked="page = $event"
        >
        </pdf>
        <el-button
          :disabled="!isDataMounted"
          :loading="loading"
          style="margin-top: 12px"
          type="danger"
          @click.once="createSignerDocument"
        >
          Send
        </el-button>
      </el-card>
    </transition>
  </el-card>
</template>

<script>
import axios from 'axios';
import pdf from 'vue-pdf';
import RsAnvilApi from '../api/rsAnvilApi';
import { CUSTOMER_API_BASE, RS_ANVIL_API, ANVIL_TEMPLATE_ID2, UNITS_API_BASE } from '../env';
import State from './Sate';
import leaseIntegration from '../utils/leaseIntegration';
import { countries } from '../utils/countries';
import { getFacility } from '../utils/commonApi';
import { round } from '../utils/pricing';
import getParsedTokenTitle from '../utils/keycloak';

export default {
  name: 'CustomerRentalAgreement',
  components: { pdf, State },
  props: {
    moveIn: { type: Date },
    moveOut: { type: Date },
    facility: { type: String, required: true },
    customerId: { type: String, required: true },
    leaseId: { type: String },
    leasePrice: { type: Number },
    proratedRent: { type: Number },
    deposit: { type: String },
    units: { type: Array, default: () => [] },
    unitsHaveOnlyIds: { type: Boolean, default: false },
  },
  async mounted() {
    this.loading = true;
    this.facilityData = await getFacility(this.facility, { token: this.$keycloak.token });
    await this.getCustomer();
    await this.getUnitsData();

    this.companyForm.country = this.customer.country;
    this.companyForm.state = this.customer.orgState;
    this.companyForm.taxId = this.customer.taxId;
    this.companyForm.typeOfEntity = this.customer.entity;
    this.contactForm.name = this.customer.primaryContact && this.customer.primaryContact.name ? this.customer.primaryContact.name : '';
    this.contactForm.email = this.customer.email;
    this.contactForm.title = this.customer.primaryContact && this.customer.primaryContact.title ? this.customer.primaryContact.title : '';
    this.contactForm.address = this.customer.address;
    this.contactForm.address2 = this.customer.address2;
    this.contactForm.phone = this.customer.phone;
    this.details.industry = this.customer.business;
    this.details.subIndustry = this.customer.subIndustry;
    this.loading = false;
    this.managerName = this.$keycloak.tokenParsed.name;
  },
  computed: {
    countrySelected() {
      if (this.companyForm.country === 'us') {
        return 'United States of America';
      } else if (this.companyForm.country === 'ca') {
        return 'Canada';
      } else if (this.companyForm.country === 'mx') {
        return 'Mexico';
      } else if (this.companyForm.country === 'pr') {
        return 'Puerto Rico';
      }
      return 'Bahamas';
    },
    cityStatePostcode() {
      return `${this.customer.city ? this.customer.city : ''} ${this.customer.state ? this.customer.state : ''} ${this.customer.zip ? this.customer.zip : ''}`.trim();
    },
    warehouseUnitSize() {
      return this.unitsData.filter(unit => unit.type === 'Warehouse').map(item => item.computedSize).reduce((p, c) => p + c, 0);
    },
    officeUnitSize() {
      return this.unitsData.filter(unit => unit.type === 'Office').map(item => item.computedSize).reduce((p, c) => p + c, 0);
    },
    parking() {
      return this.unitsData.filter(unit => unit.type === 'Parking').length;
    },
    managerTitle() {
      return getParsedTokenTitle(this.$keycloak);
    },
  },
  data() {
    return {
      facilityData: {},
      loading: false,
      active: 0,
      templateId: null,
      unitsData: [],
      pdf: null,
      countries,
      entityOptions: [
        { label: 'Corporation', value: 'Corporation' },
        { label: 'Limited Liability Company', value: 'Limited Liability Company' },
        { label: 'Limited Liability Partnership', value: 'Limited Liability Partnership' },
        { label: 'Limited Partnership', value: 'Limited Partnership' },
        { label: 'Other', value: 'Other' },
        { label: 'Sole Proprietorship (Canada)', value: 'Sole Proprietorship (Canada)' },
        { label: 'Partnership (Canada)', value: 'Partnership (Canada)' },
        { label: 'Corporation (Canada)', value: 'Corporation (Canada)' },
        { label: 'Other (Canada)', value: 'Other (Canada)' },
      ],
      industryOptions: [
        'Auto Repair / Maintenance',
        'Computers / Electronics',
        'Construction / Remodeling',
        'Construction Materials / Supplies',
        'Consumer Services',
        'eCommerce / Online Retail',
        'Grocery / Food Wholesale',
        'Home Staging',
        'Logistics',
        'Manufacturing',
        'Media / Entertainment',
        'Moving Company / Services',
        'Non-Profit',
        'Personal Storage',
        'Real Estate Agents / Appraiser',
        'Sports / Recreation',
        'Textiles / Apparel',
        'Warehousing / Commercial Storage',
        'Wholesale / Distribution',
      ],
      subIndustryOptions: [
        'Long Term / Dead storage',
        'Equipment / supplies storage',
        'eCommerce / Order fulfillment',
        '3PL / Transload',
        'General warehousing',
        'R&D / Prototyping / Testing',
        'Manufacturing',
        'Wholesale & Distribution',
        'Assembly',
        'Athletic Training',
        'Showroom / Retail',
        'Other',
      ],
      totalPages: 0,
      managerName: '',
      title: '',
      naics: '',
      isDataMounted: false,
      page: 1,
      preview: false,
      customer: null,
      payload: {},
      customerContactBackup: {
        name: '',
        address1: '',
        address2: '',
        phone: '',
        email: '',
      },
      details: {
        term: '3 months',
        hoursOfAccess: '24/7',
        onSiteEmployees: null,
        industry: '',
        subIndustry: '',
      },
      utilities: {
        rsImprovements: '',
        memberObligationImprovements: '',
        memberRightImprovements: '',
        utils: '',
        lienHolders: '',
      },
      companyForm: {
        typeOfEntity: null,
        country: '',
        state: '',
        taxId: '',
      },
      companyRules: {
        entityType: [
          { required: true, message: 'Please select Entity type', trigger: 'blur' },
        ],
      },
      contactForm: {
        name: '',
        title: '',
        address: '',
        address2: '',
        cityStatePostcode: '',
        phone: '',
        email: '',
      },
    };
  },
  methods: {
    checkValidationErrors(etchResponse) {
      if (!etchResponse || !etchResponse.errors || !etchResponse.errors.length) {
        return 0;
      }

      let validationErrorCount = 0;
      // Parse GraphQL validation errors
      for (let i = 0; i < etchResponse.errors.length; i += 1) {
        const error = etchResponse.errors[i];
        if (error.name === 'ValidationError' && error.fields) {
          const primaryContactErrors = error.fields.filter(field => ['name', 'signers[0].name'].includes(field.property));
          if (primaryContactErrors.length) {
            this.$notify.error({
              title: 'Validation Error',
              message: 'Missing or invalid data for Customer Primary Contact.',
            });
            validationErrorCount += 1;
          }
        }
      }

      return validationErrorCount;
    },
    getTotalRemainingDays() {
      const moveIn = this.moveIn;
      const moveOut = this.moveOut;
      const date = moveIn.getDate();
      const currentYear = moveIn.getFullYear();
      const currentMonth = moveIn.getMonth();
      const totalDaysInCurrentMonth = new Date(
        currentYear,
        currentMonth + 1,
        0,
      ).getDate();

      if (moveOut && currentMonth === moveOut.getMonth() && currentYear === moveOut.getFullYear()) {
        const moveOutDay = moveOut.getDate();
        return moveOutDay - date > 0 ? (moveOutDay - date) + 1 : 1;
      }

      return totalDaysInCurrentMonth - date > 0
        ? (totalDaysInCurrentMonth - date) + 1
        : 1;
    },
    getTotalDaysOfMoveInMonth() {
      const moveIn = this.moveIn;
      const currentYear = moveIn.getFullYear();
      const currentMonth = moveIn.getMonth();
      return new Date(currentYear, currentMonth + 1, 0).getDate();
    },
    computeProratedSecurityFee(securityFee) {
      const totalProrateDays = this.getTotalRemainingDays();
      const totalDaysOfMonth = this.getTotalDaysOfMoveInMonth();

      if (totalProrateDays >= totalDaysOfMonth) {
        return securityFee;
      }
      const oneDayPrice = securityFee / totalDaysOfMonth;
      return totalProrateDays > 0
        ? round(oneDayPrice * totalProrateDays)
        : 0;
    },
    setCountryValue() {
      this.companyForm.country = this.countrySelected;
    },
    setState(state) {
      this.companyForm.state = state;
    },
    next() {
      switch (this.active) {
        case 0:
          return this.$refs.company.validate((isValid) => {
            if (!isValid) {
              return;
            }

            this.contactForm.cityStatePostcode = this.cityStatePostcode;
            this.active += 1;
          });
        case 1:
          return this.$refs.contact.validate((isValid) => {
            if (!isValid) {
              return;
            }

            this.active += 1;
          });
        case 2:
          return this.$refs.backup.validate((isValid) => {
            if (!isValid) {
              return;
            }

            this.active += 1;
          });
        case 3:
          return this.$refs.details.validate((isValid) => {
            if (!isValid) {
              return;
            }

            this.active += 1;
          });
        case 4:
          this.active += 1;
          break;
        case 5:
          this.active += 1;
          break;
        default:
          break;
      }
    },
    async getUnitsData() {
      const result = this.units;
      if (this.unitsHaveOnlyIds) {
        this.units.forEach( async item => {
          const unitsData = await axios.get(
            `${UNITS_API_BASE}/unit/${item}`,
            {
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            },
          );

          this.unitsData.push(unitsData.data);
        });

        return this.unitsData;
      }
      this.unitsData = [...result];
    },
    async generatePdf() {
      this.loading = true;
      const anvilApi = new RsAnvilApi(this.$keycloak.token);
      await this.preparePayload();

      const response = await anvilApi.generatePdf(this.payload, null, this.templateId);

      this.pdf = response.data.data;

      this.loading = false;
      this.preview = true;
    },
    async getCustomer() {
      this.loading = true;
      const customer = await axios.get(
        `${CUSTOMER_API_BASE}/customers/v1/${this.customerId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );
      this.customer = customer.data;

      this.isDataMounted = true;
      this.loading = false;
      return customer.data;
    },
    async preparePayload() {
      this.templateId = this.facilityData.anvilTemplateId || ANVIL_TEMPLATE_ID2;
      const response = await axios.get(`${RS_ANVIL_API}/cast/${this.templateId}`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      const payloadFields = response.data.cast.fieldInfo.fields;

      const payloadTypeIds = payloadFields.map(item => item.id);
      const parkingUnits = this.unitsData.filter(item => item.type === 'Parking');
      const parkingNames = parkingUnits.map(item => item.name).toString();
      const warehouseUnits = this.unitsData.filter(item => item.type === 'Warehouse');
      const warehouseNames = warehouseUnits.map(item => item.name).toString();
      const officeUnits = this.unitsData.filter(item => item.type === 'Office');
      const officeNames = officeUnits.map(item => item.name).toString();

      let monthlyOpex = 0;
      let totalLicensePlusOpex = 0;
      let proratedTotalLicensePlusOpex = 0;

      if (this.facilityData && this.facilityData.securityFee && this.facilityData.securityFee.enabled && this.facilityData.securityFee.fee) {
        for (const unit of this.unitsData) {
          const unitSecurityFee = round((this.facilityData.securityFee.fee * unit.computedSize) / 100);
          monthlyOpex += unitSecurityFee;
          proratedTotalLicensePlusOpex += this.computeProratedSecurityFee(unitSecurityFee)
        }
      }
      totalLicensePlusOpex = this.leasePrice + monthlyOpex;
      proratedTotalLicensePlusOpex += this.proratedRent;

      const anvil = leaseIntegration({
        customer: {
          ...this.contactForm,
          company: this.customer.company,
          taxId: this.companyForm.taxId,
          subIndustry: this.customer.subIndustry,

        },
        country: this.countrySelected === 'United States of America' ? 'USA' : this.countrySelected,
        entity: this.companyForm.typeOfEntity,
        state: this.companyForm.state,
        address3: this.contactForm.cityStatePostcode,
        title: this.contactForm.title,
        contactBackup: this.customerContactBackup,
        proratedRent: `${this.$options.filters.currencySign(Number(this.proratedRent), this.$root.state.facilityData)}`,
        leasePrice: `${this.$options.filters.currencySign(Number(this.leasePrice), this.$root.state.facilityData)}`,
        moveIn: this.moveIn,
        deposit: this.deposit,
        details: this.details,
        managerName: this.managerName,
        managerTitle: this.managerTitle,
        utils: this.utilities,
        naics: this.naics,
        warehouseSize: this.warehouseUnitSize,
        officeSize: this.officeUnitSize,
        parking: this.parking,
        parkingNames,
        warehouseNames,
        officeNames,
        monthlyOpex: `${this.$options.filters.currencySign(Number(monthlyOpex), this.$root.state.facilityData)}`,
        totalLicensePlusOpex: `${this.$options.filters.currencySign(Number(totalLicensePlusOpex), this.$root.state.facilityData)}`,
        proratedTotalLicensePlusOpex: `${this.$options.filters.currencySign(Number(proratedTotalLicensePlusOpex), this.$root.state.facilityData)}`,
      });

      for (const payloadItemId of payloadTypeIds) {
        this.payload[payloadItemId] = `${typeof anvil[payloadItemId]}` === 'function' ? anvil[payloadItemId]() : anvil[payloadItemId];
      }
    },
    async createSignerDocument() {
      if (this.loading) {
        this.$notify.warn({
          message: 'Already processing, please wait.',
        });
        return;
      }
      this.loading = true;
      const anvilApi = new RsAnvilApi(this.$keycloak.token);

      try {
        await this.preparePayload();
      } catch (err) {
        console.log(err);
      }

      const response = await anvilApi.generateAgreement({
        payload: this.payload,
        customerEmail: this.customer.email,
        managerEmail: this.$keycloak.tokenParsed.email,
        managerName: this.managerName,
        customerName: this.customer.primaryContact.name,
        facilityCode: this.facilityData.code,
        replyToEmail: this.facilityData.email,
        leaseId: this.leaseId,
      }, this.templateId);

      const validationErrorCount = this.checkValidationErrors(response);

      if (validationErrorCount > 0) {
        // Don't proceed if there are validation errors
        this.loading = false;
        return;
      }

      const etchPacket = response.data.data.createEtchPacket;

      this.$emit('confirmed', etchPacket);
      this.loading = false;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CustomerRentalAgreement.vue